<template>
	<div>
		<vx-card title="Totalen" class="text-md" noShadow cardBorder>
			<div class="vx-row">
				<div class="vx-col w-full">
					<vx-tooltip text="Totale waarde bestelling" class="float-right">
						Totaal €{{ order.order.order_price }}
					</vx-tooltip>
				</div>

				<div class="vx-col w-full">
					<vx-tooltip text="Totale bemiddelingsbijdrage" class="float-right">
						Bemiddelingsbijdrage €{{ this.order.order.order_commission.toFixed(2) }}
					</vx-tooltip>
				</div>

				<div class="vx-col w-full">
					<vx-tooltip text="Totale winst" class="float-right text-xl">
						<b>Marge €{{ this.totalMarge }}</b>
					</vx-tooltip>
				</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
export default {
	props: {
		order: Object,
	},
	data() {
		return {
			totalMarge: 0,
		}
	},
	mounted() {
		this.calculateTotalMarge();
	},
	methods: {
		calculateTotalMarge() {
			this.totalMarge = (this.order.order.order_price.toFixed(2) - this.order.order.order_commission.toFixed(2)).toFixed(2);
		},
	}
}
</script>
